import React from "react"

/**
 * Force LTR rendering inside RTL layouts (phone numbers, +country codes, etc.).
 */
const LtrText = ({ children, className = "", as: Component = "span" }) => (
  <Component
    dir="ltr"
    className={className}
    style={{ unicodeBidi: "isolate", display: "inline-block" }}
  >
    {children}
  </Component>
)

export default LtrText
